import React from "react";
import { Typography } from "@mui/material";

const Footer = () => {
  return (
    <Typography
      variant="body2"
      sx={{
        fontFamily: "Lora, serif",
        fontSize: "0.9rem",
        color: "#F5EDE3",
        textAlign: "center",
        opacity: 0.7,
        py: 1,
      }}
    >
      Designed by H M IT Solutions
    </Typography>
  );
};

export default Footer;